<script>
import { Meses } from '@constants/Text'
import moment from 'moment'

/**
 * Sample: <FilterDates :start-date.sync="filters.startDate" :end-date.sync="filters.endDate" @reload="loadDre"/>
 */
export default {
  name: 'FilterDates',
  emits: [
    // 'input',
    'update:startDate',
    'update:endDate',
    // 'showNext',
    'reload',
    // 'update:show', // ?
  ],
  props: {
    // value: {
    //   type: String,
    //   default: '',
    // },
    show: {
      type: Boolean, // para quando for atualizado no pai, alterar aqui tb
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    colorIconeCalendario: {
      type: String,
      default: '#8e8e8e',
    },
    // label: {
    //   type: String,
    //   default: 'Data',
    // },
    // isStart: {
    //   type: Boolean,
    // },
    labelStart: {
      type: String,
      default: 'Data início',
    },
    labelEnd: {
      type: String,
      default: 'Data fim',
    },
    frequency: {
      type: String,
      default: 'M',
      validator(val) {
        return ['M', 'Q', 'Y'].includes(val)
      },
    },
    widthFields: {
      type: Number,
      default: 175,
    },
    useLabelAbove: {
      type: Boolean,
      default: false,
    },
    /**
     * Permite limpar individualmente data inicial ou final via "X" ao
     * lado do input. Emite update:startDate/update:endDate com ''.
     */
    clearable: {
      type: Boolean,
      default: false,
    },
    /**
     * Empilha os campos (data início / data fim) na vertical, em largura
     * total. Default false mantém o layout horizontal lado a lado.
     */
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      year: 2023,
      showMenu: false,
      options: [
        {
          text: '3 meses',
        },
        {
          text: '6 meses',
        },
        {
          text: '12 meses',
        },
        {
          text: 'Este ano',
        },
      ],
      optionSelected: '',
      timeoutClose: null,
      startInput: null,
      endInput: null,
      startFocus: true,
    }
  },
  computed: {
    MONTHS() {
      return Meses.map((month, index) => {
        const date = moment(new Date(this.year, index)).endOf('month')
        return {
          text: month,
          value: date.format('YYYYMMDD'),
          mask: date.format('DD/MM/YYYY'),
        }
      })
    },
    dates() {
      let startMonth = null
      if (this.startDate && this.startDate.length) {
        const [d, m, y] = this.startDate.split('/')
        startMonth = y + m + d
      }
      let endMonth = null
      if (this.endDate && this.endDate.length) {
        const [d, m, y] = this.endDate.split('/')
        endMonth = y + m + d
      }
      return [startMonth, endMonth]
    },
    isStart() {
      return this.startFocus
    },
    fieldMaxWidth() {
      return this.vertical ? '100%' : this.widthFields + 'px'
    },
  },
  watch: {
    show(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.showMenu = newVal
      }
    },
    showMenu(newVal) {
      if (newVal) {
        this.onOpen()
      } else {
        this.$emit('reload')
      }

      this.$emit('update:show', newVal)
    },
  },
  created() {
    this.setCurrentYear()
  },
  methods: {
    onOpen() {
      if (this.$refs.startInput) {
        this.startFocus = this.$refs.startInput.isFocused
      }
      const date = this.startFocus ? this.startDate : this.endDate
      if (date) {
        this.year = Number(date.split('/')[2]) || new Date().getFullYear()
      }
      this.checkNeedSelectOption()
    },
    checkNeedSelectOption() {
      const hasOption = this.options.some((opt) => {
        const { start, end } = this._formatDatesOptions(opt)
        if (start === this.startDate && end === this.endDate) {
          this.optionSelected = opt
          return true
        }
        return false
      })
      if (!hasOption) {
        this.optionSelected = {}
      }
    },
    setCurrentYear() {
      this.year = new Date().getFullYear()
    },
    isBetweenDates({ value }) {
      if (!this.dates[0] || !this.dates[1]) {
        return false
      }
      return value >= this.dates[0] && value <= this.dates[1]
    },
    _formatDatesOptions(opt) {
      let start = ''
      let end = ''
      if (opt.text === 'Este ano') {
        start = moment().startOf('year').endOf('month')
        end = moment().endOf('month')
      }
      if (opt.text === '12 meses') {
        start = moment().add(-12, 'months').endOf('month')
        end = moment().add(-1, 'months').endOf('month')
      }
      if (opt.text === '6 meses') {
        start = moment().add(-6, 'months').endOf('month')
        end = moment().add(-1, 'months').endOf('month')
      }
      if (opt.text === '3 meses') {
        start = moment().add(-3, 'months').endOf('month')
        end = moment().add(-1, 'months').endOf('month')
      }
      if (start) {
        if (typeof start !== 'string') {
          start = start.format('DD/MM/YYYY')
        }
      }
      if (end) {
        if (typeof end !== 'string') {
          end = end.format('DD/MM/YYYY')
        }
      }
      return { start, end }
    },
    _focusEnd() {
      if (this.$refs.endInput) {
        this.$refs.endInput.focus()
      }
      this.startFocus = false
    },
    selectOption(opt) {
      this.optionSelected = opt
      const { start, end } = this._formatDatesOptions(opt)
      if (start) {
        this.$emit('update:startDate', start)
      }
      if (end) {
        this.$emit('update:endDate', end)
      }
      if (start && end) {
        this.setCurrentYear()
        // this.close({ next: false })
      }
    },
    selectDate(month) {
      // parametro para saber se eh a data fim ou inicio e selecionar primeiro baseado nisso
      if (this.isStart) {
        if (!this.dates[1] || month.value < this.dates[1]) {
          // selecionou uma data fim
          this.$emit('update:startDate', month.mask)
        } else if (this.dates[1] && month.value > this.dates[1]) {
          // selecionou uma data inicio
          // salvar a data inicio atual
          const old = this.endDate
          // colocar nova data inicio
          const newDate = month.mask
          this.$emit('update:endDate', newDate)
          // colocar nova data fim
          this.$emit('update:startDate', old)
        } else if (month.value === this.dates[1]) {
          this.$emit('update:startDate', month.mask)
        }

        this._focusEnd()
      } else {
        if (month.value > this.dates[0]) {
          // selecionou uma data fim
          this.$emit('update:endDate', month.mask)
        } else if (month.value < this.dates[0]) {
          // selecionou uma data inicio
          // salvar a data inicio atual
          const start = this.startDate
          // colocar nova data inicio
          const newStart = month.mask
          this.$emit('update:startDate', newStart)
          // colocar nova data fim
          this.$emit('update:endDate', start)
        } else if (month.value === this.dates[0]) {
          this.$emit('update:endDate', month.mask)
        }
      }

      this.$nextTick(() => {
        this.checkNeedSelectOption()
      })

      // this.close()
    },
    close({ next = true } = {}) {
      // colocar readonly na parada
      clearTimeout(this.timeoutClose)
      this.timeoutClose = setTimeout(() => {
        this.showMenu = false

        if (this.isStart && next) {
          this.$emit('showNext', true)
        }
      }, 700)
    },
    formatMonthDate(val) {
      if (val && typeof val === 'string') {
        return val.split('/').slice(1).join('/')
      }
      return val
    },
    selectInput(on, isStart, event) {
      this.startFocus = isStart
      if (!this.showMenu) {
        this.onOpen()
      }
      if (on) {
        on.click(event)
      } else {
        this.showMenu = true
      }
    },
    clearDate(isStart, event) {
      if (event) {
        event.stopPropagation()
        event.preventDefault()
      }
      this.$emit(isStart ? 'update:startDate' : 'update:endDate', '')
      this.$nextTick(() => this.checkNeedSelectOption())
    },
  },
}
</script>

<template>
  <div>
    <v-menu
      v-model="showMenu"
      :max-width="290"
      :close-on-content-click="false"
      transition="scroll-y-transition"
      min-width="auto"
      min-height="auto"
      left
      offset-y
      v-bind="$attrs"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          class="d-flex"
          :class="{ 'flex-column': vertical }"
          :style="{ gap: vertical ? '0.75rem' : '1rem' }"
        >
          <div class="d-flex flex-column">
            <span v-if="useLabelAbove" class="filter-label"
              >{{ labelStart }}
            </span>
            <v-text-field
              ref="startInput"
              :value="formatMonthDate(startDate)"
              :label="!useLabelAbove ? labelStart : undefined"
              readonly
              placeholder="MM/AAAA"
              hide-details
              dense
              outlined
              :style="{ 'max-width': fieldMaxWidth }"
              class="new-ux align-icon-search"
              v-bind="attrs"
              @click="selectInput(on, true, $event)"
            >
              <template v-slot:prepend-inner>
                <icon-svg
                  name="calendar"
                  size="20"
                  :color="colorIconeCalendario"
                />
              </template>
              <template v-if="clearable && startDate" v-slot:append>
                <v-icon
                  small
                  color="#8E8E8E"
                  aria-label="Limpar data inicial"
                  @click.stop="clearDate(true, $event)"
                >
                  mdi-close-circle
                </v-icon>
              </template>
            </v-text-field>
          </div>
          <div class="d-flex flex-column">
            <span v-if="useLabelAbove" class="filter-label"
              >{{ labelEnd }}
            </span>
            <v-text-field
              ref="endInput"
              :value="formatMonthDate(endDate)"
              :label="!useLabelAbove ? labelEnd : undefined"
              readonly
              placeholder="MM/AAAA"
              hide-details
              dense
              class="new-ux align-icon-search"
              outlined
              :style="{ 'max-width': fieldMaxWidth }"
              v-bind="attrs"
              @click="selectInput(on, false, $event)"
            >
              <template v-slot:prepend-inner>
                <icon-svg
                  name="calendar"
                  size="20"
                  :color="colorIconeCalendario"
                />
              </template>
              <template v-if="clearable && endDate" v-slot:append>
                <v-icon
                  small
                  color="#8E8E8E"
                  aria-label="Limpar data final"
                  @click.stop="clearDate(false, $event)"
                >
                  mdi-close-circle
                </v-icon>
              </template>
            </v-text-field>
          </div>
        </div>
      </template>
      <div class="bg-white filter-dates container-filter">
        <div class="d-flex justify-content-between align-items-center">
          <v-btn icon @click="year--">
            <v-icon> mdi-chevron-left </v-icon>
          </v-btn>
          <span class="text-heading-small text-black-light"> {{ year }} </span>
          <v-btn icon @click="year++">
            <v-icon> mdi-chevron-right </v-icon>
          </v-btn>
        </div>
        <div class="d-flex mt-1.5rem" style="flex-wrap: wrap; row-gap: 4px">
          <div
            v-for="month in MONTHS"
            :key="month.value"
            class="item-month"
            :class="{
              'item-month-between': isBetweenDates(month),
              'item-month-selected-first': startDate === month.mask,
              'item-month-selected-last': endDate === month.mask,
            }"
            @click="selectDate(month)"
          >
            <div class="font-medium text-sm"> {{ month.text }} </div>
          </div>
        </div>
        <v-divider class="my-1rem" />
        <div class="d-flex justify-content-between">
          <div
            v-for="option in options"
            :key="option.text"
            class="item-option"
            :class="{ 'item-option-selected': option === optionSelected }"
            @click="selectOption(option)"
          >
            <span class="font-semibold text-xs">
              {{ option.text }}
            </span>
          </div>
        </div>
        <div class="d-flex justify-end">
          <BaseButton
            primary
            sm
            text
            class="mt-5"
            minWidth="80px"
            @click="showMenu = false"
          >
            Filtrar
          </BaseButton>
        </div>
      </div>
    </v-menu>
  </div>
</template>

<style lang="sass" scoped>
.v-menu__content:has(.filter-dates)
  overflow: hidden

.filter-dates
  &.container-filter
    width: 290px
    padding: 24px
    border-radius: 8px
    box-shadow: 0px 42px 80px rgba(207, 208, 216, 0.24), 0px 8px 20px rgba(207, 208, 216, 0.16), 0px 3px 7px rgba(73, 75, 91, 0.16)

.item-month
  //padding: 12px 8px
  padding: 3px
  width: 16.66%
  cursor: pointer
  color: #8e8e8e
  transition: all 0.1s ease-in-out
  div
    border: 1px solid transparent
    border-radius: 50%
    width: 35px
    display: flex
    align-items: center
    justify-content: center
    aspect-ratio: 1 / 1
    margin: auto
    transition: all 0.3s ease-in-out
  &:hover
    div
      border-color: #ebebeb
    //background-color: var(--primary-lighter)
    //color: var(--primary)
  &-between
    background-color: var(--primary-lighter)
    color: var(--primary)
  &-selected
    &-last
      background-color: var(--primary)
      color: #FFF
      border-top-right-radius: 8px
      border-bottom-right-radius: 8px
    &-first
      background-color: var(--primary)
      color: #FFF
      border-top-left-radius: 8px
      border-bottom-left-radius: 8px
.item-option
  color: #8e8e8e
  cursor: pointer
  transition: all 0.3s ease
  &:hover
    color: var(--primary)
  &::after
    content: ' '
    position: absolute
    background-color: var(--primary)
    bottom: -10px
    width: 0px
    height: 4px
    right: 0
    left: 0
    margin: auto
    border-radius: 100px
    transition: all 0.2s ease-in-out
  &-selected
    color: var(--primary)
    position: relative
    &::after
      width: 72%

.filter-label
  font-family: 'Archivo', sans-serif
  font-size: 14px
  font-weight: 300
  color: #030309
  margin-bottom: 6px !important
</style>
